import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useParticipantIds, useDailyEvent, useDaily } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { pageAtom, topMessageAtom, screenShareAtom } from '../../State';
import { ReactComponent as CopyLinkSVG } from '../Images/buttons/linkCopyButton.svg';
import { useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CloseSVG } from '../Images/header/closeButtonHair.svg';

export default function InfoBox({ isLive }) {
  const screenShareState = useRecoilValue(screenShareAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const pageState = useRecoilValue(pageAtom);
  const { t } = useTranslation();
  const [isShowInfo, setIsShowInfo] = useState(true);

  //URL取得
  const urlParam = useParams();
  var roomID = urlParam.id;

  var url = isLive == false ? 'https://faceless.ooo/' + roomID : 'https://faceless.ooo/l/' + roomID;

  //クリップボードにコピー
  const copyURL = () => {
    navigator.clipboard.writeText(url).then(
      function () {
        setTopMessageState({ type: 'copied', message: t('top.Copied Successfully') });
      },
      function (err) {},
    );
  };

  const hideDiv = () => {
    setIsShowInfo(false);
  };

  //レンダービュー
  return (
    <>
      {screenShareState == null && isMobile == false && isShowInfo && (
        <div className="info-box" style={{ opacity: pageState == 'nftList' ? 0.2 : 1 }}>
          <div className="info-box-close" onClick={hideDiv}>
            <CloseSVG />
          </div>
          <h1>{t('bottom.Invite Others')}</h1>
          {/* <p>Invite someone by sharing this link:</p> */}

          <div id="infoURLBox" onClick={copyURL}>
            <div className="linkDesc">{t('bottom.Tap to copy invite URL')} </div>
            <span ide="infoURLText">{url}</span>
            <CopyLinkSVG />
          </div>
        </div>
      )}
    </>
  );
}
